export default __webpack_public_path__ + "static/media/mag3.795f7dca.png";